module.exports = __webpack_public_path__ + "img/9791185971001.e70a8287.jpg";